const directv = 'DirecTV';
const freeveeLinear = 'FreeVee Linear';
const fubo = 'Fubo TV';
const peacockLinear = 'Peacock Linear';
const philo = 'Philo';
const slingtv = 'Sling TV';
const tubiLinear = 'Tubi Linear';
const telus = 'Telus';

const unitedStates = 'United States';
const unitedKingdom = 'United Kingdom';
const canada = 'Canada';
const international = 'International';

const nosey = 'Nosey';
const noseyEscandalos = 'Nosey Escandalos';
const confessByNosey = 'Confess by Nosey';
const judgeNosey = 'Judge Nosey';
const presentedByNosey = 'Presented by Nosey';

export const borrowers: string[] = [directv, freeveeLinear, fubo, peacockLinear, philo, slingtv, tubiLinear, telus];


export const borrowerTerritories: {[key: string]: string[]} = {
  [directv]: [unitedStates],
  [freeveeLinear]: [unitedKingdom, unitedStates],
  [fubo]: [unitedStates],
  [peacockLinear]: [unitedStates],
  [philo]: [international, unitedStates],
  [slingtv]: [unitedStates],
  [tubiLinear]: [unitedStates, canada],
  [telus]: [unitedStates]
}

export const borrowerTerritoryChannel: {[key: string]: {[key: string]: string[]}} = {
  [directv]: {
    [unitedStates]: [nosey]
  },
  [freeveeLinear]: {
    [unitedKingdom]: [nosey],
    [unitedStates]: [confessByNosey, judgeNosey, nosey, presentedByNosey]
  },
  [fubo]: {
    [unitedStates]: [confessByNosey, judgeNosey, nosey]
  },
  [peacockLinear]: {
    [unitedStates]: [confessByNosey, nosey]
  },
  [philo]: {
    [international]: [confessByNosey, judgeNosey],
    [unitedStates]: [confessByNosey, judgeNosey]
  },
  [slingtv]: {
    [unitedStates]: [confessByNosey, judgeNosey, nosey, noseyEscandalos]
  },
  [tubiLinear]: {
    [unitedStates]: [nosey],
    [canada]: [confessByNosey]
  },
  [telus]: {
    [unitedStates]: [confessByNosey, nosey]
  }
}

export const lenderPlatforms: {[Key: string]: string[]} = {
  [`${directv}-${unitedStates}-${nosey}`]: ['Roku'],
  [`${freeveeLinear}-${unitedKingdom}-${nosey}`]: ['Wurl'],
  [`${freeveeLinear}-${unitedStates}-${confessByNosey}`]: ['Wurl'],
  [`${freeveeLinear}-${unitedStates}-${judgeNosey}`]: ['Wurl'],
  [`${freeveeLinear}-${unitedStates}-${presentedByNosey}`]: ['Wurl'],
  [`${freeveeLinear}-${unitedStates}-${nosey}`]: ['Wurl'],
  [`${fubo}-${unitedStates}-${confessByNosey}`]: ['Roku'],
  [`${fubo}-${unitedStates}-${judgeNosey}`]: ['Roku'],
  [`${fubo}-${unitedStates}-${nosey}`]: ['Roku'],
  [`${peacockLinear}-${unitedStates}-${confessByNosey}`]: ['Roku'],
  [`${peacockLinear}-${unitedStates}-${nosey}`]: ['Amagi'],
  [`${philo}-${international}-${confessByNosey}`]: ['Wurl'],
  [`${philo}-${international}-${judgeNosey}`]: ['Wurl'],
  [`${philo}-${unitedStates}-${confessByNosey}`]: ['Wurl'],
  [`${philo}-${unitedStates}-${judgeNosey}`]: ['Wurl'],
  [`${slingtv}-${unitedStates}-${confessByNosey}`]: ['Wurl'],
  [`${slingtv}-${unitedStates}-${judgeNosey}`]: ['Amagi'],
  [`${slingtv}-${unitedStates}-${nosey}`]: ['Amagi'],
  [`${slingtv}-${unitedStates}-${noseyEscandalos}`]: ['Wurl'],
  [`${tubiLinear}-${unitedStates}-${nosey}`]: ['Amagi'],
  [`${tubiLinear}-${canada}-${confessByNosey}`]: ['Roku'],
  [`${telus}-${unitedStates}-${confessByNosey}`]: ['Roku'],
  [`${telus}-${unitedStates}-${nosey}`]: ['Roku']
}
